// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__38NvF","buttons":"Footer_buttons__1FChb"};